import { Map } from 'immutable';
import { subWeeks, addWeeks, startOfISOWeek, endOfISOWeek } from 'date-fns';

// Define initial state
const initialState = new Map({
    // Set default date for schedule
    date: new Date(),
    firstRangeFrom: startOfISOWeek(subWeeks(new Date(), 1)),
    firstRangeTo: endOfISOWeek(subWeeks(new Date(), 1)),
    secondRangeFrom: startOfISOWeek(addWeeks(new Date(), 1)),
    secondRangeTo: endOfISOWeek(addWeeks(new Date(), 2)),
});

export default (state = initialState, action) => {
    switch (action.type) {
        // Set a new schedule date
        case 'SCHEDULE.SET_DATE': {
            return state.set('date', action.date);
        }
        case 'SCHEDULE.GENERATE_FROM_DATE': {
            return state
                .set('firstRangeFrom', action.firstRangeFrom)
                .set('firstRangeTo', action.firstRangeTo);
        }
        case 'SCHEDULE.GENERATE_TO_DATE': {
            return state
                .set('secondRangeFrom', action.secondRangeFrom)
                .set('secondRangeTo', action.secondRangeTo);
        }
        default: {
            return state;
        }
    }
};
